import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllNotifications } from '../../app/slice/chatSlice';
import { Empty, message, Spin } from 'antd';
import { decryptData, formatDateAndTime, limitWords } from '../../utils/utils';
import NotificationToggle from './NotificationToggle';
import { useNavigate } from 'react-router-dom';
import { readMessages } from '../../utils/pushNotification';
import ChatEmailIcon from '../icons/ChatEmailIcon';

export default function Notification({ onClose }) {
  const dispatch = useDispatch();
  const user_id = useSelector((store) => store.auth.userInfo.user_id);
  const notifications = useSelector((state) => state.chat.allNotification);
  const loading = useSelector((state) => state.chat.loading);
  const emailId = useSelector((store) => store.auth.userInfo.user_email);
  const comp_id = useSelector((store) => store.auth.userInfo.company_id);
  const navigate = useNavigate();
  const companyId = Number(localStorage.getItem('companyId')) || comp_id;

  const handelDelete = async (e, id) => {
    e.stopPropagation();
    try {
      const payload = {
        user_id,
        notification_id: id
      }
      await readMessages(payload);
      message.success('Delete Succesfully');
      dispatch(fetchAllNotifications({ user_id, company_id: companyId }));
    } catch (error) {
    }
  }

  const gotoNotification = async (item) => {
    try {
      const payload = {
        user_id,
        notification_id: item.notification_id
      };
      await readMessages(payload);
      dispatch(fetchAllNotifications({ user_id, company_id: companyId }));
    } catch (error) {
      console.error("Failed to delete notification on click", error);
    }

    if (item.type === "chat") {
      navigate(`/admin/contracts/${item.agreement_id}?from=notification`);
    } else if (item.type === "agreement_sent") {
      navigate(`/admin/contracts/${item.agreement_id}?tab=6`);
    }
    onClose();
  };

  const handleClearAll = async () => {
    try {
      const payload = {
        user_id,
        type: "all_delete"
      }
      await readMessages(payload);
      message.success('All notifications cleared successfully');
      dispatch(fetchAllNotifications({ user_id, company_id: companyId }));
    } catch (error) {
      message.error('error');
    }
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen w-full">
        <div>

          <Spin size="large" />
        </div>
      </div>
    )
  }
  const extractEmailTag = (text) => {
    const emailTagRegex = /@[\w.-]+@[\w.-]+\.\w+\([^)]+\)/;
    const match = text?.match(emailTagRegex);
    return match ? match[0] : '';
  };
  return (
    <>
      <div className="p-4 my-4 mx-auto bg-white-300  rounded-lg overflow-hidden">
        <NotificationToggle />
      </div>
      {!notifications.length && <Empty className=' m-auto relative top-1/2' description="No notifications" />}
      {notifications.length > 0 && (
        <div className="flex justify-end max-w-md mx-auto mb-2">
          <button
            onClick={handleClearAll}
            className="text-xs px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
          >
            Clear All
          </button>
        </div>
      )}
      {notifications.map((item, idx) => (
        <div key={idx} role="button"
          onClick={() => gotoNotification(item)}
          className="my-2 max-w-md mx-auto bg-white dark:bg-[#17153B] dark:text-gray-100 shadow-md overflow-hidden ">

          <div className="flex items-center justify-between p-4 border-b">

            <div className="flex items-start gap-2 ">
              <div className="p-2 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-sm font-bold">
                <ChatEmailIcon type={item.type} />
              </div>
              <div className="flex flex-col ">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold dark:text- text-gray-900 dark:text-gray-100">{limitWords(item.document_id)}</h3>
                  <span className="bg-gray-200 text-gray-800 text-xs px-2 py-0.5 rounded-full w-6 h-6 flex items-center justify-center">
                    {item.chat_count}
                  </span>
                </div>
                <p className="text-[10px] font-medium text-gray-800 dark:text-gray-200 mb-4 break-words w-full  max-w-[250px] max-h-[50px] overflow-hidden">
                  Last Message:{" "}
                  <p className="text-green-600 text-[12px] font-bold pb-1 break-words">
                    {extractEmailTag(decryptData(item.message))}
                  </p>
                  {decryptData(item.message).replace(extractEmailTag(decryptData(item.message)), '')}
                </p>
                <span className="text-[10px] text-gray-400">{formatDateAndTime(item.latest_timestamp)}</span>
              </div>
            </div>
            <button onClick={(e) => { handelDelete(e, item.notification_id) }} className="text-gray-400 hover:text-red-500 text-lg">
              &times;
            </button>
          </div>
        </div>
      ))}
    </>
  )
}
